import React, { ComponentPropsWithoutRef, ElementType } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

import { ErrorType } from '../../../../common/contexts/app-error-context';
import { selectStyleSelectorShown } from '../../../../common/store/ui';
import WizardLayout from '../../../../common/components/wizard-layout/WizardLayout';
import { useMobile } from '../../../../common/components/responsive/Responsive';

import './ErrorView.scss';

export interface ErrorViewProps extends ComponentPropsWithoutRef<ElementType> {
  className?: string;
  error;
}

const ErrorView = ({ className, error, ...props }: ErrorViewProps) => {
  const isMobile = useMobile();
  const styleSelectorShown = useSelector(selectStyleSelectorShown);
  if (isMobile && styleSelectorShown) {
    return null;
  }

  return (
    <WizardLayout
      className={classNames('error-view', className)}
      {...props}
      title="Ooops! An error occurred"
      description={
        <>
          {error.type === ErrorType.External_API && (
            <>
              We've noticed an unexpected error with your request. Our team is
              aware of the problem and investigating a fix.
              <br />
              <a
                className="error-view__mapbox_status_page_link"
                href="https://status.mapbox.com/"
                target="_blank"
                rel="noreferrer"
              >
                Visit Mapbox status page
              </a>
            </>
          )}

          {error.type === ErrorType.Internal_API &&
            "We've noticed an unexpected error with your request. Our team is aware of the problem and investigating a fix."}

          {error.type === ErrorType.Client &&
            "We've noticed an unexpected error. Our team is aware of the problem and investigating a fix."}
        </>
      }
      hasCloseButton={true}
    />
  );
};

ErrorView.propTypes = {
  error: PropTypes.shape({
    type: PropTypes.oneOf(Object.values(ErrorType)),
  }),
};

export default ErrorView;
